import { createAppSlice } from '../createAppSlice';
import { transformerArray } from '../transformer';

export type ModuleState = {
  loading: boolean;
  userModules?: Module[];
  moduleList: Module[];
  moduleListAdminLog: any[];
};

const initialState: ModuleState = {
  loading: false,
  moduleList: [],
  moduleListAdminLog: []
};

export const moduleSlice = createAppSlice({
  name: 'modules',
  initialState,
  reducers: (create) => ({
    fetchModules: create.asyncThunk(
      async () => {
        const response = await apiFetcher.get('module');
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.moduleList = transformerArray(action.payload);
        },
        rejected: (state) => {
          state.loading = false;
          state.moduleList = [];
        }
      }
    ),
    fetchModulesAdminLog: create.asyncThunk(
      async () => {
        const response = await apiFetcher.get('module/admin-logs');
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.moduleListAdminLog = transformerArray(action.payload);
        },
        rejected: (state) => {
          state.loading = false;
          state.moduleListAdminLog = [];
        }
      }
    ),
    fetchUserModules: create.asyncThunk(
      async (query?: Record<string, any>) => {
        const response = await apiFetcher.get('user/module', { query });
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.userModules = transformerArray(action.payload);
        },
        rejected: (state) => {
          state.loading = false;
          state.userModules = [];
        }
      }
    )
  }),

  selectors: {
    watchModules: (module) => module.userModules,
    watchModuleList: (module) => module.moduleList,
    watchModuleLoading: (module) => module.loading,
    watchModulesAdminLog: (module) => module.moduleListAdminLog
  }
});

export const {
  watchModuleLoading,
  watchModules,
  watchModuleList,
  watchModulesAdminLog
} = moduleSlice.selectors;

export const { fetchUserModules, fetchModules, fetchModulesAdminLog } =
  moduleSlice.actions;
